import { Box, Button, Typography } from '@mui/material';
import { CloudArrowUp, X } from 'phosphor-react';
import { useState } from 'react';
import DocumentIcon from '../../assets/Icons/icon';
import { useModal } from '../../context/ModalProvider/useModal';

export const UploadDocumentModal = () => {
  const { setValue } = useModal();
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [isDraggingOver, setIsDraggingOver] = useState(false);

  const handleDragOver = (event: { preventDefault: () => void }) => {
    event.preventDefault();
    setIsDraggingOver(true);
  };
  const handleDragLeave = () => {
    setIsDraggingOver(false);
  };

  const handleDrop = (event: any) => {
    event.preventDefault();
    const file = event.dataTransfer.files[0];

    getFile(file);
  };

  const handleAddFile = (e: any) => {
    const file = e.target.files![0];
    getFile(file);
  };

  const onRemove = () => {
    getFile(null);
  };

  const getFile = (file: File | null) => {
    setSelectedFile(file);
    setValue(file);
  };

  if (!!selectedFile) {
    return (
      <Box padding={'32px 32px 44px 32px'}>
        <Box
          border={'1px solid #E3DDE6'}
          p={'8.5px 12px'}
          borderRadius={'4px'}
          display={'flex'}
          justifyContent={'space-between'}
          alignItems={'center'}
        >
          <Box display={'flex'} alignItems={'center'} gap={'8px'}>
            <DocumentIcon />
            <Typography
              sx={{
                fontSize: '12px',
                lineHeight: '15px',
                fontWeight: '600',
                color: '#202A2D',
              }}
            >
              {selectedFile?.name}
            </Typography>
          </Box>
          <X size={16} cursor={'pointer'} onClick={onRemove} color='#655C68' />
        </Box>
      </Box>
    );
  }

  return (
    <Box
      padding={'32px'}
      onDragOver={handleDragOver}
      onDrop={handleDrop}
      onDragLeave={handleDragLeave}
    >
      <Box
        display={'flex'}
        justifyContent={'center'}
        alignItems={'center'}
        flexDirection={'column'}
        border={'1px dashed #E3DDE6'}
        padding={'32px'}
        borderRadius={'4px'}
        gap={'10px'}
        style={{ borderColor: isDraggingOver ? '#3293DB' : '#E3DDE6' }}
      >
        <CloudArrowUp size={36} color={'#3293DB'} weight='fill' />
        <Typography
          fontSize={'14px'}
          color={'#655C68'}
          lineHeight={'17px'}
          variant='h5'
        >
          Upload a document or drag and drop
        </Typography>
        <Button
          sx={{
            background: '#3293DB',
            color: '#fff',
            maxWidth: '158px',
            width: '100%',
            fontSize: '14px',
            lineHeight: '17px',
          }}
          variant='contained'
          component='label'
        >
          Choose File
          <input onChange={handleAddFile} hidden type='file' />
        </Button>
      </Box>
    </Box>
  );
};
